import { PropsWithChildren } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { env } from '@bridebook/web/lib/env';

export const Recaptcha = ({ children }: PropsWithChildren) => (
  <GoogleReCaptchaProvider reCaptchaKey={env.RECAPTCHA_PUBLIC_KEY} useEnterprise>
    {children}
  </GoogleReCaptchaProvider>
);
